import React from 'react'

const PILL_TEXT = '#ffffff'
const LEVEL_BG: Record<string, string> = {
  High: '#d7383c',
  Medium: '#f1a33b',
  Low: '#a3a242',
}

/** Values are NoiseLevel as stored (upper-case); labels are display casing. */
export const AI_NOISE_LEVEL_OPTIONS = [
  {value: 'HIGH', label: 'High'},
  {value: 'MEDIUM', label: 'Medium'},
  {value: 'LOW', label: 'Low'},
]

/** Accepts the API display value (High) or the raw DB value (HIGH); '' when not scored. */
export function formatAiNoiseLevel(level?: string | null): string {
  const upper = (level ?? '').trim().toUpperCase()
  return AI_NOISE_LEVEL_OPTIONS.find((o) => o.value === upper)?.label ?? ''
}

const AiNoiseBadge: React.FC<{level?: string | null}> = ({level}) => {
  const label = formatAiNoiseLevel(level)
  if (!label) return <span className='text-muted'>—</span>
  return (
    <span
      className='badge fw-semibold text-center'
      style={{
        backgroundColor: LEVEL_BG[label],
        color: PILL_TEXT,
        padding: '6px 12px',
        borderRadius: 20,
      }}
    >
      {label}
    </span>
  )
}

export default AiNoiseBadge
